import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { sleep } from '@/utils/helper';

// 查询价格所属类型
export const queryServiceTargets: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setServiceTargets', { data: [], loading: true });
    await sleep(2);
    const res = [
      { optionKey: '1', optionValue: '个人' },
      { optionKey: '2', optionValue: 'KA企业' },
      { optionKey: '3', optionValue: '品牌商' },
      { optionKey: '4', optionValue: '城市服务中心' },
    ];
    commit('setMembers', { data: res });
  } catch (e) {
    commit('setMembers', { data: [] });
  }
};
